var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.147 2.228a.65.65 0 1 0-.92.919l18.626 18.625a.65.65 0 0 0 .92-.919zM20.994 18.898V5.46a2 2 0 0 0-2-2H5.555l1.649 1.649h11.287a1 1 0 0 1 1 1v11.287zM3.016 5.163l1.46 1.46v9.487c1.363-2.43 3.664-5.65 3.664-5.65l4.391 6.421 1.016-1.187 5.744 5.744a2 2 0 0 1-.297.022h-14a2 2 0 0 1-2-2v-14q0-.152.022-.297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.494 9.46a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M18.371 16.276l-1.98-3.905-.888 1.037z"
  })));
};
export default SvgNoImage;